import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jliteral(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
  <title>Java literals tutorial For Beginners</title>
<meta name="description" content="Java literal tutorial for beginners.those value fixed to a variable and refer to fixed values.This is known as known as literal in java" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java literal
,literal in java,java literals,java octal literal,java hexadecimal literal,java array literal syntax,java literals javatpoint,java literal set,java representation of octal literal 6
,java literal int,java multiline literal string,java print literal"/>
<link rel="canonical" href="https://www.codeexampler.com/java-literals" />
</Helmet>


<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Literals in Java</h1>
    <div className="first">
        <a href="/java-string">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-data-types">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Q-what is java literals?</h2>
   <p className="mt-4 para"> <span className="bold">Answer</span> Those values are fixed to a variable and refer to fixed values. That is known as<span className="re"> Literals in Java</span>.</p>
   <p className="mt-4 para"> 1, literal is also known as constants<br/>
2, literal depends upon its type<br/>
3, Java literals have many primitive data types<br/>
</p>



<h2 className="headings">Literal in Java Example:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        
          {"\n"}
          <span className="qwerty-2">&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"Code Exampler";</span>

          {"\n"} {"\n"}

          <span className="qwerty-2">&nbsp;int </span>
          <span className="qwerty-5">is a data_types </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;a</span>
          <span className="qwerty-5"> is a variable</span>
          {"\n"}
          <span className="qwerty-8">&nbsp;=</span>
          <span className="qwerty-5"> is an operator</span>
          {"\n"}
          {"\n"}
          <span className="qwerty-10">&nbsp;Code Exampler  <span className="qwerty-4">is a java string literal </span></span>
  
      {"\n"}
         
     {"\n"}
    
    
    
    
       
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">There are Six types of Literals in Java:<br/>
</h2>
<h3  className="mt-4 mh2">1, <span className="re">String Literals</span><br/>
2, <span className="gr">Integer literals</span><br/>
3, <span className="bl">Float literals</span><br/>
4, <span className="yl">Character literals</span><br/>
5, <span className="re">Boolean literals</span><br/>
6, <span className="bl">Null literals</span>
</h3>
<h2 className="mt-4 mh2">1, String literal in Java Example: <br/></h2>



    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        
          {"\n"}
          <span className="qwerty-2">&nbsp;String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"Hello";</span>

          {"\n"}
          <span className="qwerty-2">&nbsp;String </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"Ram";</span>

          {"\n"}


  <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-8">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"} {"\n"}
          <span className="qwerty-5">&nbsp;OR</span>
          {"\n"} {"\n"}


          <span className="qwerty-2">&nbsp;String </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">,</span>
    <span className="qwerty-4">b;</span>

          {"\n"}
          <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"Hello";</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"CodeExampler";</span>
    {"\n"}
    <span className="qwerty-2">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-8">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
         
     {"\n"}
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello </span>  
          <span className="qwerty-5">Ram </span>         
          {"\n"}
          <span className="qwerty-6">&nbsp;Hello </span> 
          <span className="qwerty-7">CodeExampler </span>         
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">2, Integer literal in Java Examples:</h2>


    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        
          {"\n"}
          <span className="qwerty-2">&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">10;</span>

          {"\n"}
          <span className="qwerty-2">&nbsp;int </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">20;</span>

          {"\n"}


  <span className="qwerty-10">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-8">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"} {"\n"}
          <span className="qwerty-5">&nbsp;OR</span>
          {"\n"} {"\n"}


          <span className="qwerty-2">&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">,</span>
    <span className="qwerty-4">b;</span>

          {"\n"}
          <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">120;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">200;</span>
    {"\n"}
    <span className="qwerty-10">&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-8">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
         
     {"\n"}
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>  
          <span className="qwerty-5">20 </span>         
          {"\n"}
          <span className="qwerty-6">&nbsp;12 </span> 
          <span className="qwerty-7">200 </span>         
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">3, Float literals in Java Example:</h2>


    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        {"\n"}
    <span className="qwerty-6">&nbsp;float </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">400.8206</span>
    <span className="qwerty-6">f;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40.25</span>
    <span className="qwerty-6">f;</span>
    {"\n"}
    {"\n"}
    <span className="qwerty-5">OR</span>

    {"\n"} {"\n"}





    <span className="qwerty-7">&nbsp;double </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">400.8206</span>
    <span className="qwerty-7">d;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40.25</span>
    <span className="qwerty-7">d;</span>
    {"\n"}
    {"\n"}
    <span className="qwerty-5">OR</span>

    {"\n"} {"\n"}
    <span className="qwerty-6">&nbsp;float </span>
    <span className="qwerty-4">a;</span>
    {"\n"}
    <span className="qwerty-7">&nbsp;double </span>
    <span className="qwerty-4">b;</span>

    {"\n"}
    <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">400.8206</span>
    <span className="qwerty-6">f;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty">=</span>
    <span className="qwerty-1">40.25</span>
    <span className="qwerty-7">d;</span>
    {"\n"}

         
     {"\n"}
    
    
    
    
       
        </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">4, Character literals in Java-</h2>

<br/>
<h2 className="headings">Using charAt() Method :</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        
          {"\n"}
          <span className="qwerty-2">String </span>
    <span className="qwerty-4">a;</span>

          {"\n"}         
          <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">"CodeExampler";</span>

          {"\n"}         
          <span className="qwerty-3">char </span>
    <span className="qwerty-4">h</span>
    <span className="qwerty">=</span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">.</span>
    <span className="qwerty-6">charAt</span>
    <span className="qwerty-1">(</span>
        <span className="qwerty-1">2</span>
      <span className="qwerty-1">); </span>
    
    {"\n"}
  
    <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">c</span>
      <span className="qwerty-1">);</span>
      {"\n"}
         
     {"\n"}
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;d </span>  
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>

<h2 className="mt-4 mh2">5, Boolean literals in java Example:</h2>



    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
        
          {"\n"}
          <span className="qwerty-8">boolean </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">true;</span>

          {"\n"}
          <span className="qwerty-8">boolean </span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">false;</span>

          {"\n"}


  <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-8">""</span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"} {"\n"}
          <span className="qwerty-5">&nbsp;OR</span>
          {"\n"} {"\n"}


          <span className="qwerty-8">boolean </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8">,</span>
    <span className="qwerty-4">b;</span>

          {"\n"}
          <span className="qwerty-4">a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">true;</span>
    {"\n"}
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">false;</span>
    {"\n"}
    <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-10">System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
         
     {"\n"}
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;true </span>  
          <span className="qwerty-5">false  </span>         
          {"\n"}
          <span className="qwerty-3">&nbsp;true  </span>
          {"\n"} 
          <span className="qwerty-5">&nbsp;false </span>         
          {"\n"}
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">Null literals in Java</h2>
<p className="para mt-4">Null literals are used to indicate that this object is not available more.</p>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-string">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-data-types">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>

)

}
export default Jliteral;